import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PrefixType } from '../../interfaces/Prefix'

const pageSizeSlice = (prefix: PrefixType, initialState = 25) =>
    createSlice({
        name: `${prefix}/pageSize`,
        initialState,
        reducers: {
            switchPageSize: (state, action: PayloadAction<number>) => action.payload,
            resetPageSize: () => initialState,
        },
    })

const pageSize = (prefix: PrefixType, initialState = 25) => pageSizeSlice(prefix, initialState).reducer

export const pageSizeActions = (prefix: PrefixType, initialState = 25) => pageSizeSlice(prefix, initialState).actions

export default pageSize
